import { render, staticRenderFns } from "./labeled-control-layout.vue?vue&type=template&id=665e0524&scoped=true"
import script from "./labeled-control-layout.vue?vue&type=script&lang=js"
export * from "./labeled-control-layout.vue?vue&type=script&lang=js"
import style0 from "./labeled-control-layout.vue?vue&type=style&index=0&id=665e0524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e0524",
  null
  
)

export default component.exports